import axios from "axios";
import i18next from 'i18next';

import {store} from "../configureStore";
import {
    loadBotUserByIdRequestFail,
    loadBotUserByIdRequestStart,
    loadBotUserByIdRequestSuccess,

    loadBotUserSchemaByIdRequestFail,
    loadBotUserSchemaByIdRequestStart,
    loadBotUserSchemaByIdRequestSuccess,

    subscribeToFlowRequestFail,
    subscribeToFlowRequestStart,
    subscribeToFlowRequestSuccess,

    unsubscribeFromFlowRequestFail,
    unsubscribeFromFlowRequestStart,
    unsubscribeFromFlowRequestSuccess,


    blockedBotUsersStart,
    blockedBotUsersSuccess,
    blockedBotUsersFail,
    getBlockedBotUsersStart,
    getBlockedBotUsersSuccess,
    getBlockedBotUsersFail,
} from '../actions/Audience'
import {toast} from "react-toastify";


export const loadBotUserById = (botUserId, successCallback, errorCallback) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            
            headers: {
                Authorization: `Bearer  ${store.getState().Auth.authToken}`,
                'Content-Type': 'application/json',
            },
        });

        dispatch(loadBotUserByIdRequestStart(botUserId));

        instance.get(`bot/bot_users/${botUserId}/`).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(loadBotUserByIdRequestSuccess(response.data.result));
                    successCallback && successCallback(response.data.result);
                } else {
                    dispatch(loadBotUserByIdRequestFail(response.data.errors));
                    errorCallback && errorCallback(response.data.errors);
                }
            },
            error => {
                dispatch(loadBotUserByIdRequestFail(error));
                errorCallback && errorCallback(error);
            },
        );
    }
};


export const loadBotUserSchemaById = (botUserId, successCallback, errorCallback) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            
            headers: {
                Authorization: `Bearer  ${store.getState().Auth.authToken}`,
                'Content-Type': 'application/json',
            },
        });

        dispatch(loadBotUserSchemaByIdRequestStart(botUserId));

        let data = {
            shop_id: store.getState().Shops.activeShop.id,
        };
        instance.get(`bot/bot_users/${botUserId}/form_schema/`, {params: data}).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(loadBotUserSchemaByIdRequestSuccess(response.data.result));
                    successCallback && successCallback(response.data.result);
                } else {
                    dispatch(loadBotUserSchemaByIdRequestFail(response.data.errors));
                    errorCallback && errorCallback(response.data.errors);
                }
            },
            error => {
                dispatch(loadBotUserSchemaByIdRequestFail(error));
                errorCallback && errorCallback(error);
            },
        );
    }
};


export const subscribeToFlow = (botUserId, flowId, successCallback, errorCallback) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            
            headers: {
                Authorization: `Bearer  ${store.getState().Auth.authToken}`,
                'Content-Type': 'application/json',
            },
        });

        dispatch(subscribeToFlowRequestStart(botUserId));

        let data = {
            shop_id: store.getState().Shops.activeShop.id,
            bot_user_id: botUserId,
            flow_id: flowId,
        };
        instance.post(`/bot/bot_user/subscribe_to_flow/`, data).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(subscribeToFlowRequestSuccess(response.data.result));
                    toast.success(i18next.t('thunks.audience.toast_subscribed_to_scenario', `Subscribed to flow`));
                    successCallback && successCallback(response.data.result);
                } else {
                    dispatch(subscribeToFlowRequestFail(response.data.errors));
                    errorCallback && errorCallback(response.data.errors);
                }
            },
            error => {
                dispatch(subscribeToFlowRequestFail(error));
                toast.error(i18next.t('errors.common.request_sent', 'Error sending request'));
                errorCallback && errorCallback(error);
            },
        );
    }
};


export const unsubscribeFromFlow = (botUserId, flowId, successCallback, errorCallback) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            
            headers: {
                Authorization: `Bearer  ${store.getState().Auth.authToken}`,
                'Content-Type': 'application/json',
            },
        });

        dispatch(unsubscribeFromFlowRequestStart(botUserId));

        let data = {
            shop_id: store.getState().Shops.activeShop.id,
            bot_user_id: botUserId,
            flow_id: flowId,
        };
        instance.post(`/bot/bot_user/unsubscribe_from_flow/`, data).then(
            (response) => {
                if (response.data.status === 'ok') {
                    dispatch(unsubscribeFromFlowRequestSuccess(response.data.result));
                    toast.success(i18next.t('thunks.audience.toast_unsubscribed_from_scenario', `Unsubscribed from flow`));
                    successCallback && successCallback(response.data.result);
                } else {
                    dispatch(unsubscribeFromFlowRequestFail(response.data.errors));
                    toast.error(i18next.t('errors.common.request_sent', 'Error sending request'));
                    errorCallback && errorCallback(response.data.errors);
                }
            },
            error => {
                dispatch(unsubscribeFromFlowRequestFail(error));
                toast.error(i18next.t('errors.common.request_sent', 'Error sending request'));
                errorCallback && errorCallback(error);
            },
        );
    }
};

export const blockedBotUsers = (botUserId, action) => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,

            headers: {
                Authorization: `Bearer  ${store.getState().Auth.authToken}`,
                'Content-Type': 'application/json',
            },
        });

        dispatch(blockedBotUsersStart(botUserId));

        const url = 'shop/blocked_bot_users/';
        switch (action) {
            case 'block_off':
                let data = {
                    shop_id: store.getState().Shops.activeShop.id,
                    bot_user_id: botUserId,
                };
                instance.post(url, data).then(
                    response => {
                        dispatch(blockedBotUsersSuccess(response.data));
                        dispatch(getBlockedBotUsers());
                        toast.success(i18next.t('thunks.audience.the_user_is_blocked', 'The user is blocked'), {autoClose: 1500});
                    },
                    error => {
                        dispatch(blockedBotUsersFail(error));
                        toast.error(i18next.t('errors.common.request_sent', 'Error sending request'));
                    },
                );
                break;
            case 'unlock':
                instance.delete(`${url}${store.getState().Shops.activeShop.id}/?bot_user_id=${botUserId}`).then(
                    response => {
                        dispatch(blockedBotUsersSuccess(response.data));
                        dispatch(getBlockedBotUsers());
                        toast.success(i18next.t('thunks.audience.user_unlocked', 'User unlocked'), {autoClose: 1500});
                    },
                    error => {
                        dispatch(blockedBotUsersFail(error));
                        toast.error(i18next.t('errors.common.request_sent', 'Error sending request'));
                    },
                );
                break;
        }
    }
};

export const getBlockedBotUsers = () => {
    return function (dispatch) {
        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,

            headers: {
                Authorization: `Bearer  ${store.getState().Auth.authToken}`,
                'Content-Type': 'application/json',
            },
        });

        dispatch(getBlockedBotUsersStart());

        instance.get(`shop/blocked_bot_users/${store.getState().Shops.activeShop.id}/`).then(
            response => {
                if (response.data.length) {
                    dispatch(getBlockedBotUsersSuccess(response.data));
                } else {
                    dispatch(getBlockedBotUsersSuccess([]));
                }
            },
            error => {
                dispatch(getBlockedBotUsersFail(error));
            }
        );
    }
};
